export default __webpack_public_path__ + "static/media/remote_control_1.a819ab89.png";